module.exports = __webpack_public_path__ + "static/media/service2.d3a8d325.png";